import { cn } from 'src/utils'
import { MainThemeVariants } from 'src/types'
import { useThemeContext } from 'src/contexts'

import { useNavigation } from 'src/hooks/useNavigation'
import { useGetColorThemeAndNext } from 'src/hooks/useGetColorThemeAndNext'
import { useAppSelector } from 'src/hooks/useAppSelector'

import { Button } from 'src/components/shadcn/button'

export const ButtonNavigateToCars = (): JSX.Element => {
  const { goToMyCars } = useNavigation()
  const { mainThemeColor, colorTheme } = useGetColorThemeAndNext()
  const { isDark } = useThemeContext()
  const { activeCar } = useAppSelector(state => state.user)

  return (
    <Button variant="ghost" className="rounded-[10px]" onClick={goToMyCars}>
      <h2
        className={cn(
          `
          text-[16px] font-semibold ${isDark ? 'text-black' : 'text-white'} tracking-wide  px-1 rounded shadow-sm
        `,
          `${colorTheme === MainThemeVariants.DEFAULT ? '' : 'text-white'}`,
        )}
        style={{ backgroundColor: mainThemeColor }}
      >
        {activeCar}
      </h2>
    </Button>
  )
}
